import { ApiResult, PaginatedResponse, request, safeRequest } from '@synergy/api';

import {
    BonusSettlementCustomer,
    BonusSettlementCustomerOverviewDetail,
} from '../models/bonus-settlement-customer-overview';

export class BonusSettlementsCustomerOverviewApi {
    constructor(protected baseUrl: string) {}

    public getBonusSettlementsCustomerOverview(
        id: number,
        searchParams: URLSearchParams
    ): Promise<ApiResult<PaginatedResponse<BonusSettlementCustomer>>> {
        return safeRequest(
            () => request.get(`${this.baseUrl}/bonus-settlements/${id}/customers`, { params: searchParams }),
            response => response.data
        );
    }

    public getBonusSettlementsCustomerOverviewDetails(
        id: number
    ): Promise<ApiResult<BonusSettlementCustomerOverviewDetail>> {
        return safeRequest(
            () => request.get(`${this.baseUrl}/bonus-settlements/${id}/customer-details`),
            response => response.data
        );
    }

    public postCompleteBonusSettlementCustomers(
        bonusSettlementId: number,
        completeAll?: boolean,
        customerIds?: number[]
    ): Promise<ApiResult<BonusSettlementCustomer>> {
        return safeRequest(
            () =>
                request.post(`${this.baseUrl}/bonus-settlements/${bonusSettlementId}/complete-customers`, {
                    completeAll,
                    customerIds,
                }),
            response => response.data
        );
    }

    public postReloadCustomers(bonusSettlementId: number): Promise<ApiResult<void>> {
        return safeRequest(
            () => request.post(`${this.baseUrl}/bonus-settlements/${bonusSettlementId}/customers/reload`),
            response => undefined
        );
    }

    public postReloadCustomer(bonusSettlementId: number, customerId: number): Promise<ApiResult<void>> {
        return safeRequest(
            () => request.post(`${this.baseUrl}/bonus-settlements/${bonusSettlementId}/customers/${customerId}/reload`),
            response => undefined
        );
    }

    public postReopenBonusSettlementCustomer(bonusSettlementId: number, customerId: number): Promise<ApiResult<null>> {
        return safeRequest(
            () => request.post(`${this.baseUrl}/bonus-settlements/${bonusSettlementId}/customers/${customerId}/reopen`),
            () => null
        );
    }
}
